import { isPlainObject } from '../_util/is';
export function hasPrefixSuffix(props) {
    const { allowClear } = props;
    const clearEnabled = isPlainObject(allowClear) ? !allowClear.disabled : allowClear;
    return !!(props.prefix || props.suffix || clearEnabled || props.showCount);
}
